// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/tag.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { tagsApi } from "../../api/tags";
import type { Tag } from "../../api/types";
// override-block:imports BEGIN
import { createElement } from "react";
// CHG-1294 — per-page RBAC gate wiring (consumes GATE_CATALOG).
import { GATE_CATALOG } from "../../auth/gateCatalog";
import { toGate } from "../../auth/toGateProp";
// override-block:imports END

// override-block:helpers BEGIN
function colorSwatch(hex: string | null | undefined): ReturnType<typeof createElement> {
  if (!hex) return createElement("span", { style: { color: "var(--color-text-muted)" } }, "—");
  return createElement("span", {
    style: {
      display: "inline-block",
      width: 16,
      height: 16,
      borderRadius: 4,
      background: hex,
      border: "1px solid var(--color-border)",
      verticalAlign: "middle",
    },
    title: hex,
    "aria-label": `Color ${hex}`,
  });
}
// override-block:helpers END

export const tagListConfig: ListPageConfig<Tag> = {
  title: "Tags",
  subtitle: "Taxonomy for donor / campaign / recurring / pledge / donation / message labeling.",
  queryKey: ["tags", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    tagsApi.listTags({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "name", direction: "asc" },
  pageSize: 50,
  rowHref: "/tags/{id}",
  search: { enabled: true, placeholder: "Search tags by name…" },
  emptyState: {
    title: "No tags yet",
    subtitle: "Tags appear here as you label donors, campaigns, recurring donations, pledges, donations, and messages.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // CHG-1325 — bulk-* keys CHG-1305 added are forward-promised for a
    // primitive-extension CHG (DRIFT-648); header actions remain on the
    // CHG-1290 GATE_CATALOG keys.
    { id: "edit", label: "Edit", variant: "secondary", permissionGate: toGate(GATE_CATALOG.tag_list["edit"], "disable") },
    { id: "merge", label: "Merge", variant: "ghost", permissionGate: toGate(GATE_CATALOG.tag_list["merge"], "disable") },
    // override-block:header-actions END
  ],
  columns: [
    { field: "name", label: "Name", type: "text", sortable: true },
    // override-block:column-color BEGIN
    {
      field: "color",
      label: "Color",
      type: "custom",
      width: "64px",
      render: (row) => colorSwatch(row.color),
    },
    // override-block:column-color END
    // override-block:column-description BEGIN
    {
      field: "description",
      label: "Description",
      type: "custom",
      render: (row) =>
        row.description
          ? row.description
          : createElement("span", { style: { color: "var(--color-text-muted)" } }, "—"),
    },
    // override-block:column-description END
    // override-block:column-applied-to-count BEGIN
    {
      field: "applied_to_count",
      label: "Applied to",
      type: "custom",
      sortable: true,
      render: (row) => (row.applied_to_count != null ? String(row.applied_to_count) : "0"),
    },
    // override-block:column-applied-to-count END
    { field: "created_at", label: "Created", type: "relative-date", sortable: true },
  ],
};
